import { Play, TrendingUp } from "lucide-react";
import { Reveal, SectionHeading, SectionCta } from "./Reveal";
import { SITE_CONFIG } from "@/config/siteConfig";

const RESULTS = [
  { metric: "[RESULT 1: PRIMARY METRIC]", delta: "[BEFORE] to [AFTER]", clinic: "[CLINIC TYPE]", quote: "[SHORT OWNER QUOTE]" },
  { metric: "[RESULT 2: PRIMARY METRIC]", delta: "[BEFORE] to [AFTER]", clinic: "[CLINIC TYPE]", quote: "[SHORT OWNER QUOTE]" },
  { metric: "[RESULT 3: PRIMARY METRIC]", delta: "[BEFORE] to [AFTER]", clinic: "[CLINIC TYPE]", quote: "[SHORT OWNER QUOTE]" },
];

export const Proof = () => (
  <section id="proof" data-testid="proof-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        eyebrow="Proof, not promises"
        title={
          <>
            Results from practices <span className="italic text-champagne">that stopped the leak.</span>
          </>
        }
        copy="Real clinics, real numbers. [PLACEHOLDERS TO BE REPLACED WITH CLIENT RESULTS]"
      />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {RESULTS.map((r, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div
              data-testid={`proof-card-${i}`}
              className="h-full border border-black/10 bg-coal p-8 shadow-sm transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-champagne/50 hover:shadow-[0_20px_60px_rgba(61,165,221,0.12)]"
            >
              <TrendingUp size={20} className="text-champagne" strokeWidth={1.5} />
              <p className="mt-6 font-display text-3xl font-light text-pearl">{r.metric}</p>
              <p className="mt-2 font-mono text-sm text-champagne">{r.delta}</p>
              <p className="mt-1 font-mono text-[11px] tracking-widest uppercase text-zinc-500">{r.clinic}</p>
              <p className="mt-6 border-t border-black/10 pt-6 text-sm text-zinc-500 italic leading-relaxed">
                {r.quote}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10">
        <div
          data-testid="founder-video-slot"
          className="relative aspect-video border border-black/10 bg-carbon overflow-hidden shadow-sm"
        >
          {SITE_CONFIG.founderVideoUrl ? (
            <iframe
              src={SITE_CONFIG.founderVideoUrl}
              title="Founder video"
              className="absolute inset-0 w-full h-full"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 text-center px-6">
              {SITE_CONFIG.founderVideoPoster && (
                <img src={SITE_CONFIG.founderVideoPoster} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
              )}
              <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-champagne text-white shadow-[0_10px_40px_rgba(61,165,221,0.4)]">
                <Play size={22} className="ml-1" />
              </span>
              <p className="relative font-display text-2xl text-pearl">60 seconds with the founder.</p>
              <p className="relative font-mono text-[11px] tracking-widest uppercase text-zinc-500">
                [LOOM OR YOUTUBE EMBED PLACEHOLDER. Add the URL in siteConfig.js]
              </p>
            </div>
          )}
        </div>
      </Reveal>

      <SectionCta id="proof" label="I want results like these" />
    </div>
  </section>
);
